import React from 'react'
import { observer } from 'mobx-react-lite'
import { useFormContext } from '../Providers/FormContextProvider'
import { Divider, Segmented } from 'antd'

interface LanguageSwitcherProps {
    formContext?: any
    isLanguageSwitcher?: boolean
}

// TODO: Import AppConfig when available
const AppConfig = {
    locales: {
        en: 'English',
        uk: 'Ukrainian',
        ru: 'Russian',
    },
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = observer(
    ({ formContext, isLanguageSwitcher = true }) => {
        if (!formContext) {
            formContext = useFormContext()
        }

        // TODO: Uncomment when CrudResource is available
        // const crudContext = useCrudResourceContext();

        if (
            !formContext ||
            !formContext.isTranslatable ||
            isLanguageSwitcher === false ||
            !formContext.values?.id
        ) {
            return null
        }

        const languages = Object.keys(AppConfig.locales ?? {}).map((key) => key.toUpperCase())
        const currentLanguage = formContext.currentLanguage.toUpperCase()

        return (
            <>
                <Segmented
                    options={languages}
                    value={currentLanguage}
                    onChange={(value: string) => {
                        formContext.setCurrentLanguage(value.toLowerCase())
                        // TODO: Uncomment when CrudResource is available
                        // if (crudContext) {
                        //     crudContext.actions.reload();
                        // }
                    }}
                />
                <Divider style={{ marginTop: 10, marginBottom: 10 }} />
            </>
        )
    }
)
